export const ERROR_MESSAGES_LOGIN = "Login failed";
export const ERROR_MESSAGES_REGISTER = "Register failed";
export const ERROR_MESSAGES_LOGOUT = "Logout failed";
export const MESSAGE_COPY = "Copied!";
export const MESSAGES_CREATE_DESCRIPTION =
  "Describe what your AI Agent should do. Be as detailed as possible!";
export const MESSAGES_AI_PROCESSING = "AI is thinking...";

// Button Messages ------------------------------------------------------------

export const ERROR_MESSAGES_IMAGE_REQUIRE = "Please upload image";
export const ERROR_MESSAGES_IMAGE_SUPPORT =
  "Only .jpg, .jpeg, .png and .gif format allowed!";
export const ERROR_MESSAGES_IMAGE_FILE_SIZE = "File size limit";

export const BUTTON_PREVIEW_AGENT = "Preview Agent";
